import { cx } from "@emotion/css";
import type { ReactNode } from "react";
import { formatConversationTime } from "src/components/GlobalChatbot/groupConversationsByDate";
import type { ChatbotConversation } from "src/components/GlobalChatbot/types";

interface ConversationItemProps {
	conversation: ChatbotConversation;
	selected?: boolean;
	onSelect: (conversationId: string) => void;
	actions?: ReactNode;
	// godzina obok pytania zamiast w dolnym rzędzie
	timeInline?: boolean;
	className?: string;
	testId?: string;
}

export const ConversationItem = ({
	conversation,
	selected,
	onSelect,
	actions,
	timeInline,
	className,
	testId = "global-chatbot-history-item",
}: ConversationItemProps) => {
	const time = (
		<span className="size-12-light text-grey ml-auto">
			{formatConversationTime(conversation.createdAt)}
		</span>
	);

	return (
		<div
			data-test-id={testId}
			className={cx("chatbot-history-item", className, {
				"item-selected": selected,
			})}
			onClick={() => onSelect(conversation.id)}
		>
			<div className="chatbot-history-item-top">
				<span className="chatbot-history-item-question">
					{conversation.question}
				</span>
				{timeInline && time}
				{actions}
			</div>
			{(conversation.category || !timeInline) && (
				<span className="chatbot-history-item-meta">
					{conversation.category && (
						<span className="tag-pill tag-pill--primary">
							{conversation.category}
						</span>
					)}
					{!timeInline && time}
				</span>
			)}
		</div>
	);
};
